import { render, staticRenderFns } from "./PublicHoliday.vue?vue&type=template&id=44375973"
import script from "./PublicHoliday.vue?vue&type=script&lang=js"
export * from "./PublicHoliday.vue?vue&type=script&lang=js"
import style0 from "./PublicHoliday.vue?vue&type=style&index=0&id=44375973&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports